const env = {
    url: 'wss://queue.gimme.network:15674/ws',
    server: 'prod',
    kafka_url: 'https://kafka-rest.gimme.network/',
};

export default env;
